import React from 'react';
import './styles.css';





export const InfoProyecto = () => {


  return (
    <>


        <div className="InfoInfoProyecto-Container">

            + Info.
            
        </div>


    </>
  )
}
